import LoadAvailableProjects from './LoadAvailableProjectsSaga'

export default [LoadAvailableProjects]
